import { createSelector } from 'reselect'

const getComponents = state => state.componentModule.components
const getTheme = state => state.themeModule.themes

export const getBornes = createSelector(getComponents, components => {
  return components.filter(c => c.bornes)
})

export const getFlatThemeComponents = createSelector(getTheme, themes => {
  return themes.map(t => ({
    ...t,
    inputs: t.inputs.flatMap(c => (c.enfants.length ? getFlat(c) : c)),
    outputs: t.outputs.flatMap(c => (c.enfants.length ? getFlat(c) : c)),
  }))
})

function getFlat(c) {
  return [c, ...c.enfants.flatMap(e => (e.enfants.length ? getFlat(e) : { ...e, nom: c.nom + '.' + e.nom }))]
}
